// src/components/WithdrawalPage.jsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/DeleteAccount.css";
import Header from "./Header";
import Footer from "./Footer";

const CONTACT_EMAIL = "contact@mabrook.ma";
const FORM_PDF = "/documents/Mabrook_Formulaire_Retractation.pdf";

const WithdrawalPage = () => {
  const { t } = useTranslation();

  const [form, setForm] = useState({
    product: "",
    paymentRef: "",
    orderDate: "",
    fullName: "",
    contact: "",
  });
  const [error, setError] = useState("");

  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const buildMailto = () => {
    const subject = encodeURIComponent(t("Withdrawal request"));
    const body = encodeURIComponent(
      [
        t(
          "I hereby give notice that I withdraw from my contract for the provision of the following service:",
        ),
        "",
        `${t("Subscription or membership concerned")}: ${form.product}`,
        `${t("Payment reference")}: ${form.paymentRef}`,
        `${t("Date of order")}: ${form.orderDate}`,
        `${t("Full name")}: ${form.fullName}`,
        `${t("Email address or phone number linked to the account")}: ${form.contact}`,
        "",
        `${t("Date")}: ${new Date().toLocaleDateString()}`,
      ].join("\n"),
    );
    return `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const missing = Object.values(form).some((v) => !v.trim());
    if (missing) {
      setError(t("Please fill in every field."));
      return;
    }
    window.location.href = buildMailto();
  };

  const fields = [
    {
      name: "product",
      label: "Subscription or membership concerned",
      type: "text",
    },
    { name: "paymentRef", label: "Payment reference", type: "text" },
    { name: "orderDate", label: "Date of order", type: "date" },
    { name: "fullName", label: "Full name", type: "text" },
    {
      name: "contact",
      label: "Email address or phone number linked to the account",
      type: "text",
    },
  ];

  return (
    <>
      <Header />
      <div className="da-page">
        <div className="da-card">
          <div className="da-header">
            <span className="da-eyebrow">{t("Right of withdrawal")}</span>
            <h1 className="da-title">{t("Withdrawal form")}</h1>
          </div>

          <p className="da-body">
            {t(
              "To Mabrook SARL, Boulevard Massira, Rue 6 Octobre N°6, Étage 3, Appartement 3, Casablanca 20660, Morocco.",
            )}
          </p>
          <p className="da-body">
            {t(
              "I hereby give notice that I withdraw from my contract for the provision of the service below.",
            )}
          </p>

          <form onSubmit={handleSubmit} noValidate>
            {fields.map(({ name, label, type }) => (
              <div key={name}>
                <label className="da-label" htmlFor={`wd-${name}`}>
                  {t(label)}
                </label>
                <input
                  id={`wd-${name}`}
                  className="da-input"
                  type={type}
                  name={name}
                  value={form[name]}
                  onChange={onChange}
                  autoComplete="off"
                />
              </div>
            ))}

            {error && (
              <p className="da-error" role="alert">
                {error}
              </p>
            )}

            <button type="submit" className="da-button da-button-primary">
              {t("Send my request by email")}
            </button>
          </form>

          <p className="da-help-text">
            {t(
              "Using this form is not mandatory: any clear statement sent to contact@mabrook.ma before the withdrawal period expires is valid. The period is 7 days from purchase for consumers residing in Morocco and 14 days for consumers residing in the EU/EEA or the United Kingdom, under Section 16 of the Terms of Service. Refunds are made using the same means of payment.",
            )}
          </p>

          <p className="da-footer">
            {t("Questions about a refund?")}{" "}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default WithdrawalPage;
